import React from 'react'
import { Loader } from 'lucide-react';
import { motion } from 'motion/react';

const LoaderBtn = ({isLoading, btnClasses, handler, defaultText, loadingText}) => {

    return (
        <button className={`${btnClasses} loaderBtn`} disabled={isLoading} onClick={() => handler()}>
            {isLoading ? (
                <>
                    {loadingText}
                    <motion.div
                        animate={{rotate: 360}}
                        transition={{ repeat: Infinity, duration: 2, ease: "linear" }}
                    >
                        <Loader size={15}/>
                    </motion.div>
                </>

            ) : (
                <>{defaultText}</>
            )}
        </button>    
    )

}

export default LoaderBtn;